import {Injectable} from '@angular/core';
import {WorkbenchContext, WorkbenchPluginId, WorkbenchViewKind, WorkbenchViewVisibilityKind} from '../types';

const MANUAL_TEST_PLUGINS: WorkbenchPluginId[] = ['testmgmt'];
const AUDIT_PLUGINS: WorkbenchPluginId[] = ['audit', 'a11y-tools'];

@Injectable({
    providedIn: 'root'
})
export class WorkbenchModeVisibilityService {
    isAuditMode(context?: WorkbenchContext): boolean {
        return context?.activeMode.kind === 'audit';
    }

    isManualTestMode(context?: WorkbenchContext): boolean {
        return context?.activeMode.kind === 'manual-test';
    }

    getPluginVisibilityKind(pluginId: WorkbenchPluginId): WorkbenchViewVisibilityKind {
        if (MANUAL_TEST_PLUGINS.includes(pluginId)) {
            return 'manual-test';
        }
        if (AUDIT_PLUGINS.includes(pluginId)) {
            return 'audit';
        }
        return 'generic';
    }

    isPluginVisible(pluginId: WorkbenchPluginId, context?: WorkbenchContext): boolean {
        const kind = this.getPluginVisibilityKind(pluginId);
        if (kind === 'manual-test') {
            return this.isManualTestMode(context);
        }
        if (kind === 'audit') {
            return this.isAuditMode(context);
        }
        return true;
    }

    isViewKindVisible(view: WorkbenchViewKind, context?: WorkbenchContext): boolean {
        const visibility = view.visibility || (view.pluginId ? this.getPluginVisibilityKind(view.pluginId) : 'generic');
        return this.isVisibilityKindVisible(visibility, context);
    }

    isVisibilityKindVisible(visibility: WorkbenchViewVisibilityKind, context?: WorkbenchContext): boolean {
        if (visibility === 'manual-test') {
            return this.isManualTestMode(context);
        }
        if (visibility === 'audit') {
            return this.isAuditMode(context);
        }
        return true;
    }
}
